import mixx from '../../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'repsAltas',
  data() {
    return {
      loading: false,

      precio_unitario: 1,

      cuit_ex: false,
      datos_form: {
        usuario: '',
        fecha: this.currentdate(),
        cuit: '',
        razon_social: '',
        fantasia: '',
        domicilio_fiscal: '',
        pais: '',
        provincia: '',
        localidad: '',
        partido: '',
        cod_postal: '',
        resp_fiscal: '',
        mail_contacto: '',
        nombre_contacto: '',
        tel_contacto: '',
        cant_terminales: 1,
        abono_mensual: '',
        mail_admin: '',
        usuario_fd: '',
        clave_fd: '',
        detalle: '',
        mastercard_debito_credito: true,
        visa_debito_credito: true,
        maestro: true,
        argencard: true,
        cordobesa: false,
        amex: false,
        amex_fd: false,
        cabal: false,
        naranja: false,
        sol: false,
        tuya: false,
        sidecreer: false,
        consumax: false
      },

      filtros: {
        paises: [],
        provincias: [],
        partidos: [],
        localidades: [],
        ivas: [],
        cargos: []
      }

    }
  },

  computed: {},
  mounted: function () {
    window.comp1 = this
    $('.box').boxWidget()
    this.get_paises()
    this.get_iva()
    this.calcular_abono()
  },

  methods: {

    calcular_abono() {

      this.datos_form.abono_mensual = this.datos_form.cant_terminales * this.precio_unitario

    },

    cuit_exist() {

      this.loading = true
      this.$http
        .post(
          '/SERVER/scd/admin/altaUsers/',
          {
            a: 'ce',
            cuit: this.datos_form.cuit
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {
            this.cuit_ex = true
            this.showNotification({
              msj: 'Cuit ya registrado',
              bg: 'bg-yellow'
            })
          } else {
            this.cuit_ex = false
          }

          console.log(this.cuit_ex)
          this.loading = false
        })
    },

    get_iva() {
      this.loading = true
      this.$http
        .post(
          '/SERVER/scd/admin/altaUsers/',
          {
            a: 'fi'
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {
            this.filtros.ivas = response.data.data
          }
          this.loading = false
        })
    },

    get_paises() {
      this.loading = true
      this.$http
        .post(
          '/SERVER/scd/admin/altaUsers/',
          {
            a: 'fp'
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {

            this.datos_form.usuario = response.data.user_name

            this.precio_unitario = response.data.precio_terminal.data[0][0]

            this.filtros.paises = response.data.data
            this.calcular_abono()
            this.get_provincias()
          } else {
            this.filtros.paises = []
          }
          this.loading = false
        })
    },

    get_provincias() {
      this.loading = true
      this.$http
        .post(
          '/SERVER/scd/admin/altaUsers/',
          {
            a: 'fpr',
            id: this.datos_form.pais
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {
            this.filtros.provincias = response.data.data
            this.get_localidad()
          } else {
            this.filtros.provincias = []
          }
          this.loading = false
        })
    },

    get_localidad() {
      this.loading = true
      this.$http
        .post(
          '/SERVER/scd/admin/altaUsers/',
          {
            a: 'fl',
            id: this.datos_form.provincia
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {
            this.filtros.localidades = response.data.data
            this.get_depto()
          } else {
            this.filtros.localidades = []
          }
          this.loading = false
        })
    },

    get_depto() {
      this.loading = true
      this.$http
        .post(
          '/SERVER/scd/admin/altaUsers/',
          {
            a: 'fd',
            id: this.datos_form.localidad
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {
            this.filtros.partidos = response.data.data
          } else {
            this.filtros.partidos = []
          }
          this.loading = false
        })
    },

    valida_data() {

      if (this.cuit_ex === false) {
        if (
          this.datos_form.usuario != '' &&
          this.datos_form.fecha != '' &&
          this.datos_form.cuit != '' &&
          this.datos_form.razon_social != '' &&
          this.datos_form.fantasia != '' &&
          this.datos_form.domicilio_fiscal != '' &&
          this.datos_form.pais != '' &&
          this.datos_form.provincia != '' &&
          this.datos_form.localidad != '' &&
          this.datos_form.partido != '' &&
          this.datos_form.cod_postal != '' &&
          this.datos_form.resp_fiscal != '' &&
          this.datos_form.mail_contacto != '' &&
          this.datos_form.nombre_contacto != '' &&
          this.datos_form.tel_contacto != '' &&
          this.datos_form.cant_terminales != '' &&

          this.datos_form.mail_admin != '' &&
          this.datos_form.usuario_fd != '' &&
          this.datos_form.clave_fd != ''
        ) {
          return true
        } else {
          return false
        }
      } else {
        this.showNotification({
          msj: 'Cuit ya registrado',
          bg: 'bg-yellow'
        })
        return false
      }



    },

    guardar(event) {
      event.preventDefault()



      if (this.valida_data()) {
        this.loading = true
        this.$http
          .post(
            '/SERVER/scd/admin/altaUsers/',
            {
              a: 'gu',
              data: this.datos_form
            },
            {
              withCredentials: true
            }
          )
          .then(response => {
            if (response.data.status === 1) {
              this.showNotification({
                msj: 'Registrado.',
                bg: 'bg-green'
              })
              this.reload()
            } else if (response.data.status === 1062) {
              this.showNotification({
                msj: 'Cliente ya registrado',
                bg: 'bg-yellow'
              })
            } else {
              this.showNotification({
                msj: 'Error al registrar',
                bg: 'bg-red'
              })
            }

            this.loading = false
          }).catch((e) => {
            this.showNotification({
              msj: 'Error al registrar',
              bg: 'bg-red'
            })
            this.loading = false
          })
      } else {
        this.showNotification({
          msj: 'Virifique todos los campos cargados',
          bg: 'bg-yellow'
        })
      }
    },

    reload() {
      this.datos_form.cuit = ''
      this.datos_form.razon_social = ''
      this.datos_form.fantasia = ''
      this.datos_form.domicilio_fiscal = ''
      this.datos_form.pais = ''
      this.datos_form.provincia = ''
      this.datos_form.localidad = ''
      this.datos_form.partido = ''
      this.datos_form.cod_postal = ''
      this.datos_form.resp_fiscal = ''
      this.datos_form.mail_contacto = ''
      this.datos_form.nombre_contacto = ''
      this.datos_form.tel_contacto = ''
      this.datos_form.cant_terminales = 1
      this.datos_form.abono_mensual = ''
      this.datos_form.mail_admin = ''
      this.datos_form.usuario_fd = ''
      this.datos_form.clave_fd = ''
      this.datos_form.detalle = ''
      this.datos_form.mastercard_debito_credito = true
      this.datos_form.visa_debito_credito = true
      this.datos_form.maestro = true
      this.datos_form.argencard = true
      this.datos_form.cordobesa = false
      this.datos_form.amex = false
      this.datos_form.amex_fd = false
      this.datos_form.cabal = false
      this.datos_form.naranja = false
      this.datos_form.sol = false
      this.datos_form.tuya = false
      this.datos_form.sidecreer = false
      this.datos_form.consumax = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/reps/altas/main/index.js